import image from '../../img/layouts/layout-preview-player-only.png';

export const preview = {
  image,
  description: 'Video Only',
};
